import { combineReducers } from 'redux';

import dealType from './deal_type/reducer';
import playbooks from './playbooks/reducer';
import stage from './stage/reducer';

export default combineReducers({
  canEditPropertyTypes: canEditPropertyTypes => canEditPropertyTypes || false,
  canRequirePlaybookTasks: canRequirePlaybookTasks => canRequirePlaybookTasks || false,
  dealType,
  dealTypeOptions: options => options || [],
  offices: offices => offices || [],
  paths: paths => paths || {},
  playbooks,
  propertyTypeOptions: options => options || [],
  stages: stages => stages || {},
  stage,
  users: users => users || []
});
